import * as moment from 'moment';

export class Person{
    constructor(public firstname: string,public lastname: string, public birth: moment.Moment){}
}